module.exports = __webpack_public_path__ + "static/media/GAMKONORA_ch2_20210921101149_T.fef407f5.jpg";